function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lineCharta{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-582.272 -7401)"
}, /*#__PURE__*/React.createElement("path", {
  className: "lineCharta",
  d: "M599.272,7403.429A14.571,14.571,0,1,1,584.7,7418a14.587,14.587,0,0,1,14.571-14.571m0-2.429a17,17,0,1,0,17,17,17,17,0,0,0-17-17Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(581.272 7408)"
}, /*#__PURE__*/React.createElement("path", {
  className: "lineCharta",
  d: "M13.011,11.033v5.419a1.13,1.13,0,0,1-1.129,1.129h-.753A1.13,1.13,0,0,1,10,16.452V11.033A1.13,1.13,0,0,1,11.129,9.9h.753A1.13,1.13,0,0,1,13.011,11.033ZM16.4,6.893h-.753a1.13,1.13,0,0,0-1.129,1.129v8.43a1.13,1.13,0,0,0,1.129,1.129H16.4a1.13,1.13,0,0,0,1.129-1.129V8.022A1.13,1.13,0,0,0,16.4,6.893ZM20.914,9.9h-.753a1.13,1.13,0,0,0-1.129,1.129v5.419a1.13,1.13,0,0,0,1.129,1.129h.753a1.13,1.13,0,0,0,1.129-1.129V11.033A1.13,1.13,0,0,0,20.914,9.9ZM25.43,8.022h-.753a1.13,1.13,0,0,0-1.129,1.129v7.3a1.13,1.13,0,0,0,1.129,1.129h.753a1.13,1.13,0,0,0,1.129-1.129v-7.3A1.13,1.13,0,0,0,25.43,8.022ZM11.714,7.959,16.008,5.1l4.3,3.227a.377.377,0,0,0,.492-.035l3.225-3.225.954.808a.376.376,0,0,0,.243.089.38.38,0,0,0,.127-.022.376.376,0,0,0,.243-.287l.58-3.207a.376.376,0,0,0-.5-.421l-3.068,1.1a.376.376,0,0,0-.116.641l.957.81L20.5,7.525,16.247,4.334a.378.378,0,0,0-.435-.012L11.3,7.332a.376.376,0,0,0,.418.626Z",
  transform: "translate(0 0)"
})));

var SvgLineChart = function SvgLineChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLineChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lineChart.4d4749f6.svg";
export { ForwardRef as ReactComponent };